import { render, staticRenderFns } from "./ShippingNumberTemplate.vue?vue&type=template&id=da0e1778&scoped=true&"
import script from "./ShippingNumberTemplate.vue?vue&type=script&lang=js&"
export * from "./ShippingNumberTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0e1778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da0e1778')) {
      api.createRecord('da0e1778', component.options)
    } else {
      api.reload('da0e1778', component.options)
    }
    module.hot.accept("./ShippingNumberTemplate.vue?vue&type=template&id=da0e1778&scoped=true&", function () {
      api.rerender('da0e1778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ShippingNumberTemplate.vue"
export default component.exports